import React from "react";

const AccessDeniedContent: React.FC = () => {
  return (
    <div className="text-center">
      <p className="text-gray-600 dark:text-gray-300">
        You don&apos;t have permission to access any organisations.
      </p>
      <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">
        Please contact your administrator for access.
      </p>
    </div>
  );
};

export default AccessDeniedContent;
